import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import styled from "styled-components";
import leftArrow from "../assets/bi_arrow-left.svg";
import pickup from "../assets/pickup.ffa72699.svg";

const ProductCoverdSec = () => {
  return (
    <Wrapper>
      <Container>
        <Row className="row__reverse">
          <Col md={6} lg={8} xs={12}>
            <div className="product__right">
              <img src={pickup} alt="product cover" className="image-fluid" />
            </div>
            <div className="product__right__double">
              <img src={pickup} alt="product cover" className="image-fluid" />
            </div>
          </Col>

          <Col xs={12} lg={4} md={6}>
            <div className="product__left">
              <h1>We pick-up within an hour.</h1>

              <p>
                Promptness is as important as the delivery, so we ensure that
                your order is picked up with 60 minutes of placing your order.
              </p>

              <button>
                Learn More
                <img src={leftArrow} alt="arrow" />
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .product__section1__row.row {
    padding-bottom: 70px;
  }

  .product__left {
    margin-top: 220px;
    margin-left: -40px;
    h1 {
      font-family: Gilroy-Heavy;
      font-size: 40px;
      line-height: 46px;
      color: #6300ff;
      width: 420px;
      height: 92px;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      color: #777e91;
      width: 445px;
      height: 83px;
      margin-top: 40px;
      letter-spacing: 0.6px;
    }

    button {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 14px !important;
      line-height: 19px !important;
      color: #1292ee;
      width: 150px;
      height: 52px;
      border: none;
      outline: none;
      border-radius: 5px;
      position: relative;
      background: transparent;
      margin-top: 40px;
    }

    button::before {
      content: "";
      width: 50%;
      height: 100%;
      background: rgba(18, 146, 238, 0.1);
      left: 0;
      top: 0;
      position: absolute;
      border-radius: 5px;
      transition: 0.4s all;
    }

    button:hover::before {
      width: 100%;
      border-radius: 5px;
    }
    button img {
      margin-left: 12px;
    }
  }

  .product__right {
    width: 736px;
    height: 658px;
    margin-left: -100px;
    margin-top: 30px;
    img {
      width: 100%;
      height: 100%;
      margin-left: 45px;
    }
  }

  .product__section1 {
    background: #e5edfc;
    margin-top: 50px;
    padding-top: 82px;
    padding-bottom: 40px;

    h1 {
      font-family: Gilroy-Heavy;
      font-size: 40px;
      line-height: 46px;
      color: #6300ff;
      width: 420px;
      height: 92px;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      color: #545777;
      width: 445px;
      height: 82px;
      margin-top: 22px;
    }
    h6 {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 18px;
      line-height: 22px;
      color: #1292ee;
      width: 130px;
      height: 25px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .product__right__double {
    display: none;
  }

  @media screen and (max-width: 440px) {
    .row__reverse {
      display: flex;
      flex-direction: column-reverse;
      padding-top: 80px;
      padding-bottom: 66px;
    }
    .product__section1 {
      padding-bottom: 70px;
      padding-top: 80px;
    }

    .product__left {
      margin-top: 158px;
      height: 100%;
      h1 {
        font-family: Gilroy-Heavy !important;
        font-size: 30px !important;
        line-height: 46px !important;
        color: #6300ff !important;
        width: 100% !important;
        height: 92px !important;
        padding-left: 20px;
      }
      p {
        font-family: "Manrope" !important;
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        line-height: 28px !important;
        color: #777e91;
        width: 100%;
        height: auto;
        margin-top: 40px;
        padding-left: 20px;
        -webkit-letter-spacing: 0.6px;
        -moz-letter-spacing: 0.6px;
        -ms-letter-spacing: 0.6px;
        letter-spacing: 0.6px;
      }

      button {
        font-family: Gilroy;
        font-style: normal;
        font-weight: 800;
        font-size: 14px !important;
        line-height: 19px !important;
        color: #1292ee;
        width: 150px;
        height: 52px;
        border: none;
        outline: none;
        border-radius: 5px;
        position: relative;
        background: transparent;
        margin-top: 40px;
        margin-left: 20px;
      }

      button::before {
        content: "";
        width: 50%;
        height: 100%;
        background: rgba(18, 146, 238, 0.1);
        left: 0;
        top: 0;
        position: absolute;
        border-radius: 5px;
        transition: 0.4s all;
      }

      button:hover::before {
        width: 100%;
        border-radius: 5px;
      }
      button img {
        margin-left: 12px;
      }
    }

    /* .product__right {
      margin-left: 30px;
      width: 442px;
      height: 470px;
      img {
        width: 100%;
        height: 100%;
        margin-left: 45px;
      }
    } */

    .product__left {
    }

    .product__right {
      display: none !important;
    }

    .product__right__double {
      display: block;
      width: 100%;
      margin-top: 30px;
      img {
        width: 100%;
      }
    }
  }
  @media screen and (max-width: 414px) {
    .row__reverse {
      display: flex;
      flex-direction: column-reverse;
      padding-top: 80px;
      padding-bottom: 66px;
    }
    .product__section1 {
      padding-bottom: 70px;
      padding-top: 80px;
    }

    .product__left {
      margin-top: 158px;
      height: 100%;
      h1 {
        font-family: Gilroy-Heavy !important;
        font-size: 30px !important;
        line-height: 46px !important;
        color: #6300ff !important;
        width: 100% !important;
        height: 92px !important;
        padding-left: 20px;
      }
      p {
        font-family: "Manrope" !important;
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        line-height: 28px !important;
        color: #777e91;
        width: 100%;
        height: auto;
        margin-top: 40px;
        padding-left: 20px;
        -webkit-letter-spacing: 0.6px;
        -moz-letter-spacing: 0.6px;
        -ms-letter-spacing: 0.6px;
        letter-spacing: 0.6px;
      }

      button {
        font-family: Gilroy;
        font-style: normal;
        font-weight: 800;
        font-size: 14px !important;
        line-height: 19px !important;
        color: #1292ee;
        width: 150px;
        height: 52px;
        border: none;
        outline: none;
        border-radius: 5px;
        position: relative;
        background: transparent;
        margin-top: 40px;
        margin-left: 20px;
      }

      button::before {
        content: "";
        width: 50%;
        height: 100%;
        background: rgba(18, 146, 238, 0.1);
        left: 0;
        top: 0;
        position: absolute;
        border-radius: 5px;
        transition: 0.4s all;
      }

      button:hover::before {
        width: 100%;
        border-radius: 5px;
      }
      button img {
        margin-left: 12px;
      }
    }

    /* .product__right {
      margin-left: 30px;
      width: 442px;
      height: 470px;
      img {
        width: 100%;
        height: 100%;
        margin-left: 45px;
      }
    } */

    .product__left {
    }

    .product__right {
      display: none !important;
    }

    .product__right__double {
      display: block;
      width: 395px;
      margin-top: 30px;
      img {
        width: 100%;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .product__left {
      margin-top: 0;
      margin-left: 0;
      width: 100% !important;
      h1 {
        font-family: Gilroy-Heavy;
        font-size: 36px;
        line-height: 46px;
        color: #6300ff;
        width: 100%;
        height: 92px;
      }
      p {
        font-family: "Manrope";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        color: #545777;
        width: 100%;
        height: auto;
        margin-top: 26.68px;
      }
      button {
        font-family: Gilroy;
        font-style: normal;
        font-weight: 800;
        font-size: 18px;
        line-height: 22px;
        color: #1292ee;
        width: 50%;
        padding-left: 12px;
        height: 40px;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        justify-content: flex-start;
      }
    }
  }
`;

export default ProductCoverdSec;
